const authorizationsQuery = `query authorizationsByResources($resources: [String]) {
  authorizations( resources: $resources) {
    permission
    role
    resource
  }
}`;

const authorizationsLoginQuery = `query getLoginEnabled {
  loginEnabled{
    isLocked
  }
}`;

const getAllObservationsQuery = `query getAllObservations($username: String) {
  observations(username: $username){
    observationName
    scorePercentage
    observationCount
  }
}`;

const getEventListQuery = `query getEventList($username: String, $observationName: String, $endDate: String, $periodCount: Int) {
  safetyEventList (username: $username, observationName: $observationName, endDate: $endDate, periodCount: $periodCount) {
    eventNumber
    safetyScore
    recordedOn
    siteIanaTimezone
  }
}`;

const getEventDetailsQuery = `query getEventDetails($eventNumbers: [String]) {
  safetyEventDetails(eventNumbers: $eventNumbers){
    eventNumber
    severity
    safetyScore
    recordedOn
    reviewDate
    latitude
    longitude
    company {
      companyId
      companyName
    }
    site {
      siteId
      siteName
      siteIanaTimezone
    }
    vehicle {
      vehicleId
      vehicleSerialNumber
      vehicleVin
    }
    driver {
      driverFirstName
      driverMiddleName
      driverLastName
    }
    trigger {
      triggerDescription
    }
    coaching {
      coachingObjective
      coachingOutcome
      coachingState
      queuedOn
      queuedBy
      coachedOn
      coachedBy
    }
    observations
    safetyEventVideoUrl
  }
}`;

const employeesQuery = `query getEmployees{
    company{
        employees {
            firstName
            lastName
            address
        }
    }
}`;

const safetyScoreQuery = `query getSafetyData($username: String!, $period: Int!){
  safetyScore(username: $username, period: $period){
    periodEnding
    driverScore
    targetScore
  }
}`;

export {
  authorizationsQuery,
  authorizationsLoginQuery,
  employeesQuery,
  getAllObservationsQuery,
  getEventListQuery,
  getEventDetailsQuery,
  safetyScoreQuery
};



// WEBPACK FOOTER //
// ./src/apis/GQLQueries.js